import React from 'react'
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { FormikHelpers, useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { AppRootState, useAppDispatch } from '../../app/store';
import { Navigate } from 'react-router-dom';
import { loginTC } from './auth-reducer';
import { Typography } from '@mui/material';
import { ForgotPasswordAlert } from './ForgotPasswordAlert';

type FormValuesType = {
  email: string
  password: string
}


export const Login = () => {
  const dispatch = useAppDispatch()
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)

  const formik = useFormik({
    validate: (values) => {
      if (!values.email) {
        return {
          email: 'Email is required!'
        }
      }
      if (!values.password) {
        return { password: 'Password is required!' }
      }
    },
    initialValues: {
      email: '',
      password: ''
    },
    onSubmit: async (values, formikHelpers: FormikHelpers<FormValuesType>) => {
      const action = await dispatch(loginTC({ username: values.email, password: values.password }))
      console.log(action)
      // if (loginTC.rejected.match(action)) {
      //   if (action.payload?.fieldsErrors?.length) {
      //     const error = action.payload?.fieldsErrors[0]
      //     formikHelpers.setFieldError(error.field, error.error)
      //   }
      // }
    },
  })

  if (isLoggedIn) {
    return <Navigate to={'/'} />
  }

  return <Grid container justifyContent={'center'}>
    <Grid item justifyContent={'center'}>
      <form onSubmit={formik.handleSubmit} >
        <FormControl>
          <FormLabel>
          </FormLabel>
          <FormGroup style={{ marginTop: '200px', minWidth: '300px' }}>
            <TextField
              className='textFieldLogin'
              label="Email"
              margin="normal"
              {...formik.getFieldProps('email')}
            />
            {formik.errors.email ? <div>{formik.errors.email}</div> : null}
            <TextField type="password" label="Password"
              margin="normal"
              {...formik.getFieldProps('password')}
            />
            {formik.errors.password ? <div>{formik.errors.password}</div> : null}
            <Grid container justifyContent={'right'} >
              <ForgotPasswordAlert />
            </Grid>
            <Button type={'submit'} variant={'contained'} className='btn-login' style={{ backgroundColor: '#272727' }}>
              Login
            </Button>
          </FormGroup>
        </FormControl>
      </form>
    </Grid>
  </Grid>
}
